<template>
  <v-card outlined tile class="d-flex justify-start">
    <v-select
      :items="wsTypesItems"
      item-text="FT_NAME"
      item-value="FT_ID"
      :value="value"
      :readonly="readonly"
      @input="setValue"
      label="Тип конфигурации"
      no-data-text="Нет данных"
      class="pl-3 pr-3"
    ></v-select>
  </v-card>
</template>

<script>
import { RCPT_GET_RCPT_TYPES_LIST, RCPT_SET_FILTER } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'
export default {
  name: 'wsTypeSelector',
  props: ['setGlobalFilter', 'value', 'readonly', 'hideAllOptions'],
  data () {
    return {
    }
  },
  computed: {
    wsTypesItems: {
      get: function () {
        const allOptions = this.$store.getters.getRecepturesTypesList
        return this.hideAllOptions ? allOptions.filter(itm => itm.FT_ID !== '-5') : allOptions
      }
    }
  },
  methods: {
    setValue (val) {
      console.log('wsTypeSelector:: setValue, FT_ID changed', val)
      if (this.setGlobalFilter) this.$store.dispatch(RCPT_SET_FILTER, { FT_ID: val })
      this.$emit('input', val)
    },
    getFTList () {
      const self = this
      if (this.wsTypesItems.length === 0) {
        this.$store.dispatch(RCPT_GET_RCPT_TYPES_LIST)
          .catch((err) => {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка типов рецептур: \n ${err}` })
          })
      }
    }
  },
  mounted: function () {
    console.log('wsTypeSelector mounted with value', this.value)
    if (this.wsTypesItems.length === 0) {
      this.getFTList()
    }
  },
  created () {
    console.log('wsTypeSelector created with value ', this.value, ' and readonly ', this.readonly)
  }
}
</script>
